<template>
    <div id="video-overlay-control" class="video-overlay-control">
        <div id="video-overlay-control-play" class="center-button" style="display: block;  visibility: visible;"
             @click="showPlayButton">
            <div class="innerSvg">
                <svg height="100%" version="1.1" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                     preserveAspectRatio="xMidYMid meet" style="overflow: hidden; position: relative;">
                    <path fill="#000000" stroke="#ffffff" d="M18.7,1L18.8,1L81.2,49.5L18.8,99Z" fill-opacity="0" stroke-width="5" stroke-linejoin="round"
                          style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); stroke-linejoin: round;"></path>
                </svg>
            </div>
        </div>
        <!-- Pause-Button -->
        <div id="video-overlay-control-pause" class="center-button" style="display: block; visibility: hidden;"
             @click="showPauseButton">
            <div class="innerSvg">
                <svg height="100%" version="1.1" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                     preserveAspectRatio="xMidYMid meet" style="overflow: hidden; position: relative;">
                    <path fill="#000000" stroke="#ffffff" d="M22.7,0.5V98.5M77.3,0.5V98.5" fill-opacity="0" stroke-width="10" stroke-linejoin="round"
                          style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); stroke-linejoin: round;"></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES

// METHODS
const showPlayButton = () => {
    const btnPlay = $('#video-overlay-control-play');
    document.getElementById("video-overlay-control-play").style.visibility = "visible";
    document.getElementById("video-overlay-control-pause").style.visibility = "hidden";
    store.getPlayer.play();
    btnPlay.fadeOut(1000);
};

const showPauseButton = () => {
    const btnPause = $('#video-overlay-control-pause');
    document.getElementById("video-overlay-control-play").style.visibility = "hidden";
    document.getElementById("video-overlay-control-pause").style.visibility = "visible";
    store.getPlayer.pause();
    btnPause.fadeOut(1000);
};

const handleHotspotOverlayClick = (event) => {
    document.getElementById("video-overlay-control").style.opacity = "1";
    if (store.getPlayer.getState() === 'paused' || store.getPlayer.getState() === 'idle' || store.getPlayer.getState() === 'complete') {
        const btnPlay = $('#video-overlay-control-play');
        btnPlay.fadeIn(10);
        document.getElementById("video-overlay-control-play").style.visibility = "visible";
        document.getElementById("video-overlay-control-pause").style.visibility = "hidden";
        $('#bottom-bar-pause-button').show();
        $('#bottom-bar-play-button').hide();
        store.getPlayer.play();
        btnPlay.fadeOut(1000);
    } else {
        const btnPause = $('#video-overlay-control-pause');
        btnPause.fadeIn(10);
        document.getElementById("video-overlay-control-play").style.visibility = "hidden";
        document.getElementById("video-overlay-control-pause").style.visibility = "visible";
        $('#bottom-bar-pause-button').hide();
        $('#bottom-bar-play-button').show();
        store.getPlayer.pause();
        btnPause.fadeOut(1000);
    }
};

// LYFECYCLE HOOKS
onMounted(() => {
    $(document).on("click", "#hotspot-overlay", handleHotspotOverlayClick);
});

onBeforeUnmount(() => {
    $(document).off("click", "#hotspot-overlay", handleHotspotOverlayClick);
});
</script>
